<template>
    <div class="row" v-if="dosage._destroy == undefined">
        <div class="col s1" style="width: 5px">
            <i class="material-icons dp48" style="line-height: 1.5;" v-on:click="removeDosage()">close</i>
        </div>
        <div class="col s2">
            <select v-model="dosage.substance_id" style="margin-bottom: 0px !important;">
                <option value="-1">Inny preparat...</option>
                <option v-for='substance in substances' :value="substance.id">{{substance.name}}</option>
            </select>
        </div>
        <div class="col s1 input-field" v-if="substanceId == -1">
            <input v-model="dosage.other_name" />
        </div>
        <div class="col s3 label" style="text-align: right;">
            {{$t('intervention.where_applied')}}:
        </div>
        <div class="col s5 input-field">
            <input type="text" name="placement" v-model="dosage.placement" />
        </div>
        <div class="col s2 label" style="text-align: right;">{{$t('intervention.dose')}}:</div>
        <div class="col s3 label">
            <select>
                <option value="by_database">{{$t('intervention.by_data_from_base')}}</option>
                <option value="other">..................</option>
                <option value="by_etiquette">{{$t('intervention.by_etiquette')}}</option>
            </select>
        </div>
        <div class="col s1 input-field">
            <input v-model="dosage.quantity" />
        </div>
        <div class="col s1">
            <select v-model="dosage.dosage_unit">
                <option value="ml">
                    ml
                </option>
                <option value="l">
                    l
                </option>
                <option value="g">
                    g
                </option>
                <option value="kg">
                    kg
                </option>
                <option value="pieces">
                    szt
                </option>
                <option value="ppm">
                    ppm
                </option>
                <option value="percent">
                    %
                </option>
            </select>
        </div>
        <div class="col s1">{{$t('intervention.substance_per')}}</div>
        <div class="col s1 input-field">
            <input v-model="dosage.solution_volume" />
        </div>
        <div class="col s1">
            <select v-model="dosage.solution_unit">
                <option value="ml">
                    ml
                </option>
                <option value="l">
                    l
                </option>
                <option value="g">
                    g
                </option>
                <option value="kg">
                    kg
                </option>
                <option value="pieces">
                    szt
                </option>
                <option value="m2">
                    m2
                </option>
                <option value="m3">
                    m3
                </option>
            </select>
        </div>
        <div class="col s1">
            <select v-model="dosage.solution_per_units">
                <option value="mixture">
                    {{$t('intervention.mixture')}}
                </option>
                <option value="water">
                    {{$t('intervention.water')}}
                </option>
                <option value="point">
                    {{$t('intervention.point')}}
                </option>
                <option value="surface">
                    {{$t('intervention.surface')}}
                </option>
                <option value="room">
                    {{$t('intervention.room')}}
                </option>
            </select>
        </div>
        <div class="col s1"></div>
        <div class="col s3 label">
            {{$t('intervention.total_applied')}}:
        </div>
        <div class="col s1 input-field">
            <input v-model="dosage.dose" />
        </div>
        <div class="col s1">
            <select v-model="dosage.dosage_unit">
                <option value="ml">
                    ml
                </option>
                <option value="l">
                    l
                </option>
                <option value="g">
                    g
                </option>
                <option value="kg">
                    kg
                </option>
                <option value="pieces">
                    szt
                </option>
                <option value="m2">
                    m2
                </option>
                <option value="m3">
                    m3
                </option>
            </select>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function() {
        return {}
    },
    mounted(){
    },
    methods: {
      removeDosage: function(){
        this.dosage._destroy = true
        this.$forceUpdate();
        this.$emit('removedosage', this.dosage);
      },
    },
    props: { dosage: Object, substances: Array },
    computed: {
      substanceId: {
        get: function() {
          if(this.dosage.substance_id == undefined){
            return -1;
          }else{
            return this.dosage.substance_id;
          }
        },
        set: function(value){
            if(value == -1){
              this.dosage.substance_id = -1;
            }else{
              this.dosage.substance_id = value;
            }
            this.$forceUpdate();
        }
      }
    },

}
</script>
<style scoped>
div {
    margin-left: auto;
    left: auto;
    right: auto;
    line-height: 2;
}
</style>